import React, { useEffect, useRef } from 'react';
import { ContentSection, Description, ImageSection, PageContainer, Title, Subtitle, BoldText, StyledDivider } from "./style-component";
import { CollectibleDetails } from './components/collectible-page-details';
import { useParams } from 'react-router-dom';
import { getCollectible } from '@/services/collectibles/collectibles';
import useFetch from '@/hook/useFetch/useFetch';
import { Collectible } from '@/types/collectible/collectible-type';
import { SpaceshipLoader } from '@/components/spaceship-loader/spaceship-loader';
import SEOHelmet from '@/components/SEOHelmet/SEOHelmet';
import { amplitudeAddTrack, determineProjectName } from '@/utils/amplitud/event-track';

const CollectiblePage: React.FC = () => {
  const { collectibleId } = useParams<{ collectibleId: string }>();

  const { data: collectibleFetch, loading, error } = useFetch<Collectible, string>(
    getCollectible,
    collectibleId ?? ''
  );

  const collectible = collectibleFetch;

  const firstRenderAmplitude = useRef<boolean>(true);
  useEffect(() => {
    if (collectible?.metadata?.json_data?.name && firstRenderAmplitude.current) {
      firstRenderAmplitude.current = false;
      amplitudeAddTrack(determineProjectName(`Coleccionable: ${collectible?.metadata?.json_data?.name}`), {
        title: determineProjectName(`Coleccionable: ${collectible?.metadata?.json_data?.name}`),
      })
    }
  }, [collectible]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <SpaceshipLoader height="200px" />
      </div>
    );
  }

  if (error || !collectible) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        color: 'white',
        minHeight: '50vh'
      }}>
        No se encontró el coleccionable
      </div>
    );
  }

  return (
    <PageContainer>
      <SEOHelmet
        metadata={{
          title: determineProjectName(`Coleccionable: ${collectible?.metadata?.json_data?.name}`),
          description: determineProjectName(`${collectible?.metadata?.json_data?.description ?? ''}`)
        }}
      />
      <ImageSection>
        <img src={collectible?.thumb_url} alt="Collectible" />
        <Title>{collectible?.metadata?.json_data?.name}</Title>
        <Subtitle>{collectible?.collection?.name}</Subtitle>
      </ImageSection>
      <ContentSection>
        <BoldText>Acerca de este coleccionable</BoldText>
        <Description>
          {collectible?.metadata?.json_data?.description}
        </Description>

        <StyledDivider />

        <CollectibleDetails
          blockchain_name={collectible?.blockchain?.name ?? ''}
          collection_key={collectible?.collection?.collection_key ?? ''}
          thumb_url={collectible?.thumb_url ?? ''}
          token_id={collectible?.token_id?.toString() ?? ''}
        />
      </ContentSection>
    </PageContainer>
  );
};

export default CollectiblePage;


